import React from 'react'
export default function Skills({ skills, focus, lang, t }) {
  return (
    <section className="section soft" id="skills">
      <div className="container">
        <p className="eyebrow">{t.coreFocus}</p>
        <div className="focus-grid">
          {focus[lang].map((f) => (
            <div className="focus-card" key={f.title}>
              <span className="focus-icon">{f.icon}</span>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </div>
          ))}
        </div>

        <p className="eyebrow skills-eyebrow">{t.skills}</p>
        <div className="skills-grid">
          {skills[lang].map(([title, items]) => (
            <div className="skill-card" key={title}>
              <h3>{title}</h3>
              <div>
                {items.map((x) => (
                  <span key={x}>{x}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
